import { type ReactNode, useState } from 'react';
import { useAuthStore } from '@/stores/auth';
import { SegmentedToggle } from '@/components/ui/segmented-toggle';
import { type PaymentMode, PAYMENT_MODE_OPTIONS } from '../utils/payment-mode';
import { PaymentsKanban } from './payments-kanban';
import { CalculatePaymentsButton } from './calculate-payments-button';
import { InvestmentHistoryButton } from './investment-history-button';

export function PaymentsPage(): ReactNode {
  const isAdmin = useAuthStore((s) => s.isAdmin);
  const [mode, setMode] = useState<PaymentMode>('top');
  return (
    <div className="space-y-lg">
      <div className="flex flex-wrap items-center justify-between gap-sm">
        <h2 className="text-sm font-semibold text-text-primary">Pagos</h2>
        <div className="flex items-center gap-sm">
          <SegmentedToggle
            options={PAYMENT_MODE_OPTIONS}
            value={mode}
            onChange={setMode}
          />
          {isAdmin && (
            <>
              <InvestmentHistoryButton />
              <CalculatePaymentsButton />
            </>
          )}
        </div>
      </div>
      <PaymentsKanban mode={mode} />
    </div>
  );
}
